"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var FundManagersQuery = /** @class */ (function (_super) {
    __extends(FundManagersQuery, _super);
    function FundManagersQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FundManagersQuery.prototype.getRawValue = function (executionOptions) {
        var _this = this;
        var sort = this.options.sort;
        var entity = this.getEntity(executionOptions);
        if (entity) {
            var fundManagers = this.getFundManagers(executionOptions);
            if (sort) {
                fundManagers = this.applySort(fundManagers, sort);
            }
            return fundManagers && fundManagers.map(function (fundManager) { return _this.getFundManagerResult(executionOptions, fundManager); });
        }
        return;
    };
    FundManagersQuery.prototype.getFundManagers = function (executionOptions) {
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        var _a = this.options, code = _a.code, _b = _a.collectionItemConditional, collectionItemConditional = _b === void 0 ? { conditions: [] } : _b;
        if (code && !collectionItemConditional.conditions.find(function (condition) { return condition.field === 'code'; })) {
            collectionItemConditional.conditions.push({
                field: 'code',
                operator: '=',
                value: code,
            });
        }
        var collectionItems = this.getSubCollection(executionOptions)
            .filter(function (item) { return conditionalHelper.matches(item, collectionItemConditional); });
        return collectionItems;
    };
    FundManagersQuery.prototype.getFundManagerResult = function (executionOptions, fundManager) {
        var fields = this.options.fields;
        if (!fields || fields.length === 0) {
            var _a = this.options, key = _a.key, extendedKey = _a.extendedKey;
            return this.getFundManagerValue(executionOptions, fundManager, key, extendedKey);
        }
        var fundManagerResult = {};
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            var name_1 = field.name, key = field.key, extendedKey = field.extendedKey;
            fundManagerResult[name_1] = this.getFundManagerValue(executionOptions, fundManager, key, extendedKey);
        }
        return fundManagerResult;
    };
    FundManagersQuery.prototype.getFundManagerValue = function (executionOptions, fundManager, key, extendedKey) {
        if (key === void 0) { key = null; }
        if (extendedKey === void 0) { extendedKey = null; }
        if (fundManager) {
            if (key) {
                var biographies = fundManager.biography, extended = fundManager.extended;
                if (key === 'biography' && biographies) {
                    var culture_1 = executionOptions.culture, fallbackCulture_1 = executionOptions.fallbackCulture;
                    var biographyItem = biographies.find(function (biography) { return biography.culture === culture_1; });
                    if (!biographyItem) {
                        biographyItem = biographies.find(function (biography) { return biography.culture === fallbackCulture_1; });
                    }
                    return (biographyItem && biographyItem.biography);
                }
                if (key === 'extended' && extended && extendedKey) {
                    var extendedValue = extended[extendedKey];
                    if (extendedValue) {
                        if (typeof (extendedValue) === 'string') {
                            return extendedValue;
                        }
                        return extendedValue.value;
                    }
                }
                return fundManager[key];
            }
            return fundManager;
        }
        return;
    };
    FundManagersQuery.prototype.getFundManager = function (executionOptions) {
        var fundManagers = this.getFundManagers(executionOptions);
        return this.getItem(executionOptions, fundManagers);
    };
    return FundManagersQuery;
}(BaseQuery_1.BaseQuery));
exports.FundManagersQuery = FundManagersQuery;
//# sourceMappingURL=FundManagersQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/FundManagersQuery.js
// module id = 397
// module chunks = 1